export default "__VITE_ASSET__CS0OGg72__"